export default __webpack_public_path__ + "static/media/full_heart.e75ac196.png";